import { render, staticRenderFns } from "./ChatInputBox.vue?vue&type=template&id=456cc4be&"
import script from "./ChatInputBox.vue?vue&type=script&lang=js&"
export * from "./ChatInputBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports